import React from 'react';

import LocationDesktop from 'components/Meteorology/Agro/CultureIndex/Location/Desktop';
import LocationMobile from 'components/Meteorology/Agro/CultureIndex/Location/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Location() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <LocationMobile />;
  }

  return <LocationDesktop />;
}
